//@flow
import { handleMutationError } from "../API"
import type {
  CreateAttractLoopMutation,
  UpdateAttractLoopMutation,
  AttractLoop
} from "./types"

const handleSubmit = (
  id: ?string,
  createAttractLoop: CreateAttractLoopMutation,
  updateAttractLoop: UpdateAttractLoopMutation,
  onSuccess: Function
) => async (attractLoop: AttractLoop) => {
  try {
    await (typeof id === "string"
      ? updateAttractLoop(id, attractLoop)
      : createAttractLoop(attractLoop))
    onSuccess()
  } catch (mutationError) {
    const errorString: string = mutationError
    handleMutationError(errorString)
  }
}

export default handleSubmit



// WEBPACK FOOTER //
// ./src/AttractLoops/handleSubmit.js